// extracted by mini-css-extract-plugin
export var bubble = "_o-0";
export var container = "_o-f";
export var contrastBorder = "_o-g";
export var greyOut = "_o-2";
export var initialsColor0 = "_o-3";
export var initialsColor1 = "_o-4";
export var initialsColor10 = "_o-d";
export var initialsColor11 = "_o-e";
export var initialsColor2 = "_o-5";
export var initialsColor3 = "_o-6";
export var initialsColor4 = "_o-7";
export var initialsColor5 = "_o-8";
export var initialsColor6 = "_o-9";
export var initialsColor7 = "_o-a";
export var initialsColor8 = "_o-b";
export var initialsColor9 = "_o-c";
export var initialsWrapper = "_o-1";
export var large = "_o-l";
export var medium = "_o-k";
export var mediumSmall = "_o-j";
export var mediumSmallMedium = "_o-o";
export var micro = "_o-h";
export var small = "_o-i";
export var tiny = "_o-n";
export var xTiny = "_o-m";